// Per-deployment brand selection. One codebase, two apps (holamovers | expaws).
// Design/colors are shared ("Hola design"); only the identity differs per brand.
// The active brand is chosen at build time via REACT_APP_SITE (default holamovers).
const SITE = (process.env.REACT_APP_SITE || "holamovers").toLowerCase();

const PRESETS = {
  holamovers: {
    id: "holamovers",
    name: "Hola Movers",
    tagline: "Your move to Mexico, made calm and clear.",
    logoMark: "/brand/logo-mark.png",
  },
  expaws: {
    id: "expaws",
    name: "Expaws",
    tagline: "Pet-friendly moves to Mexico, paws and all.",
    logoMark: "/brand/expaws-logo-mark.png",
  },
};

export const brand = PRESETS[SITE] || PRESETS.holamovers;
export const SITE_ID = brand.id;

// The static index.html ships with the Hola title/description; for any other
// brand, align the browser tab immediately on load (per-page <Seo> still wins).
if (typeof document !== "undefined" && brand.id !== "holamovers") {
  if ((document.title || "").includes("Hola Movers")) {
    document.title = `${brand.name} — ${brand.tagline}`;
  }
}
